import pick from 'lodash.pick';
import { loadItemFromLocalStorage } from '~/utilities/localStorage';
import type { EventTimes } from './types';

export const localStorageKey = 'merch-events';

const defaultEventTimes: EventTimes = {
  availability: 0,
  favoriteAdd: 0,
  favoriteRemove: 0,
  logIn: 0,
  logOut: 0
};

// Use defaults if nothing storage is not found, and limit to expected keys
export const eventTimes: EventTimes = {
  ...defaultEventTimes,
  ...pick(
    loadItemFromLocalStorage<EventTimes>(localStorageKey),
    Object.keys(defaultEventTimes)
  )
};
